import styles from './JSONPrettyPrint.module.css'
import { JSONPrettyPrintProps, Printable } from './types'
import { stringify } from '@betterplace/utils'
function syntaxHighlight(json: string) {
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
    (match) => {
      let cls = styles.number
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = styles.key
        } else {
          cls = styles.string
        }
      } else if (/true|false/.test(match)) {
        cls = styles.boolean
      } else if (/null/.test(match)) {
        cls = styles.null
      }
      cls ??= ''
      return `<span class='${cls}'>${match}</span>`
    }
  )
}
function JSONPrettyPrint<T extends Printable>({ json }: JSONPrettyPrintProps<T>) {
  const jsonStr = typeof json === 'string' ? json : stringify(json, 2)
  const output = syntaxHighlight(jsonStr)

  return (
    <div className={styles.JSONPrettyPrintMain}>
      <pre dangerouslySetInnerHTML={{ __html: output }}></pre>
    </div>
  )
}

export default JSONPrettyPrint
